import { inputAnatomy } from '@chakra-ui/anatomy';

import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);

const Input = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    field: {
      _placeholder: {
        opacity: 0.3,
      },
    },
  }),
});

export { Input };
